<template>
  <div>
    <div>
      <button id="checkout-button" class="hidden"></button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
    payment: Boolean,
    paymentStep: Number
  },

  data() {
    return {
      loadingPaiement: false,
    };
  },
  mounted() {
    console.log("payement component");
    this.getSession();
  },
  methods: {
    async getSession() {
      let data = new FormData();
      data.append("ticketId", Number(JSON.parse(localStorage.getItem("TICKETSELECTED")).id))
      data.append("total", this.data.total)
      let dataReservation = JSON.parse(JSON.stringify(this.$store.state.reservation));
      delete dataReservation.boissons;
      localStorage.setItem("dataReservation", JSON.stringify(dataReservation));

      data.append("datareservation", JSON.stringify(dataReservation));

      let payment_method = localStorage.getItem("payment_method");
      if (payment_method) {
        data.append("payment_method", payment_method);
      }

      data.append("_method", "get");

      this.axios.post(this.requestHttp + '/getSession', data)
        .then(({ data }) => {
          if (data.url) {
            this.$emit("stripeState", true);
            localStorage.setItem("reservation_id", data.reservation_id)
            localStorage.setItem("paiement", false);
            window.location.href = data.url;
            localStorage.setItem("session_id", data.id); // stripe me boude
          } else {
            console.error("Erreur : L'URL Stripe n'est pas fournie.");
          }
        })
        .catch(error => {

          this.$emit("CloseStripeModal")
          console.error('Erreur lors de la récupération de la session :', error);
        });
    },
  },
  computed: {
    requestHttp() {
      return this.$store.state.api;
    },
  }
};
</script>
